export type BreakpointKey = "sm" | "md" | "lg" | "xl" | "2xl";
export type ColumnsConfig = Partial<Record<BreakpointKey, number>>;

export const DEFAULT_BREAKPOINTS: Record<BreakpointKey, number> = {
	sm: 640,
	md: 768,
	lg: 1024,
	xl: 1280,
	"2xl": 1536,
};

export function sizesFromColumns(
	columns: ColumnsConfig,
	bps: Record<BreakpointKey, number> = DEFAULT_BREAKPOINTS,
	clampPx?: number,
) {
	const ordered = (Object.keys(columns) as BreakpointKey[]).sort(
		(a, b) => bps[a] - bps[b],
	);

	const segments: string[] = [];
	for (const key of ordered) {
		const max = bps[key];
		const cols = columns[key];
		const vw = Math.round(100 / (cols ?? 1));
		segments.push(`(max-width: ${max}px) ${vw}vw`);
	}

	// fallback beyond the largest bp
	const lastKey = ordered[ordered.length - 1];
	const lastCols = lastKey ? (columns[lastKey] ?? 1) : 1;
	const fallback = clampPx
		? `${Math.floor(clampPx / lastCols)}px`
		: `${Math.round(100 / lastCols)}vw`;

	return `${segments.join(", ")}, ${fallback}`;
}
